/* eslint-disable react/jsx-pascal-case */
import styled from "styled-components";
import theme, { Content_Text } from "./theme";
import ic_xmark from "../image/ic_xmark.png";

const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContainer = styled.div`
  background-color: white;
  width: 500px;
  padding: 25px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media (max-width: 800px) {
    width: 300px;
    height: 400px;
  }
`;
const CloseButton = styled.img`
  align-self: flex-end;
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  width: 20px;
  height: 20px;
  @media (max-width: 800px) {
    width: 15px;
    height: 15px;
  }
`;

const ModalContent = styled.div`
  overflow-y: auto;
  border: solid 1px ${theme.colors.barGray};
  border-radius: 8px;
  padding: 15px;
  margin-top: 15px;
`;
const ModalText = styled.p`
  font-size: 15px;
`;
const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: flex-end;
  padding-top: 20px;
`;
const Button = styled.button`
  background-color: ${theme.colors.fontLightGray};
  color: white;
  padding: 10px 30px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  border-width: 0px;
  border-radius: 8px;
  text-align: center;
  text-justify: center;
`;
function Privacy_Modal({ show, onClose, data }) {
  if (!show) {
    return null;
  }
  return (
    <ModalBackground>
      <ModalContainer>
        <CloseButton onClick={onClose} src={ic_xmark} alt={ic_xmark} />
        <Content_Text $large $xbold>
          개인정보 수집 및 이용 동의
        </Content_Text>

        <ModalContent>
          <ModalText>■ 수집하는 개인정보 항목</ModalText>
          <ModalText>
            회사는 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를
            수집하고 있습니다.
          </ModalText>
          <ModalText>0 수집항목 : 이름, 휴대폰 번호, 이메일</ModalText>
          <ModalText>
            0 개인정보 수집방법 : 홈페이지(온라인 문의,빠른상담)
          </ModalText>

          <ModalText>■개인정보 수집 및 이용목적</ModalText>
          <ModalText>
            회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.
          </ModalText>
          <ModalText>0 서비스 제공에 관한 계약 이행</ModalText>

          <ModalText>■개인정보의 보유 및 이용기간</ModalText>
          <ModalText>
            회사는 개인정보 수집 및 이용목적이 달성된 후에는 예외 없이 해당
            정보를 지체 없이 파기합니다.
          </ModalText>
        </ModalContent>
        <ModalFooter>
          <Button onClick={onClose}>뒤로가기</Button>
        </ModalFooter>
      </ModalContainer>
    </ModalBackground>
  );
}
export default Privacy_Modal;
